import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { removeToken, removeUser } from "../server";

function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    removeUser();
    navigate("/");
  };

  const customersOpen =
    pathname === "/customers" || pathname === "/corporate-approvals";

  const operationsOpen =
    pathname === "/orders" ||
    pathname.startsWith("/orders/") ||
    pathname === "/drivers";

  const catalogOpen = pathname === "/products";

  const supportOpen =
    pathname === "/support" || pathname === "/notifications";

  const reportsOpen =
    pathname === "/daily-report" || pathname === "/monthly-report";

  return (
    <nav className="navbar-vertical navbar">
      <div className="vh-100 d-flex flex-column justify-content-between">
        <ul className="navbar-nav flex-column pt-4" id="sideNavbar">
          {/* Dashboard */}
          <li className="nav-item">
            <NavLink to="/dashboard" className="nav-link">
              <i className="nav-icon bi bi-speedometer2 me-2" />
              Dashboard
            </NavLink>
          </li>

          {/* Customers */}
          <li className="nav-item">
            <a
              className={`nav-link ${customersOpen ? "" : "collapsed"}`}
              href="#"
              data-bs-toggle="collapse"
              data-bs-target="#navCustomers"
              aria-expanded={customersOpen}
            >
              <i className="nav-icon bi bi-people me-2" />
              Customers
            </a>
            <div
              id="navCustomers"
              className={`collapse ${customersOpen ? "show" : ""}`}
              data-bs-parent="#sideNavbar"
            >
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to="/customers" className="nav-link">
                    All Customers
                  </NavLink>
                </li>
                <li className="nav-item pb-2">
                  <NavLink to="/corporate-approvals" className="nav-link">
                    Corporate Approvals
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Operations: Orders + Drivers */}
          <li className="nav-item">
            <a
              className={`nav-link ${operationsOpen ? "" : "collapsed"}`}
              href="#"
              data-bs-toggle="collapse"
              data-bs-target="#navOps"
              aria-expanded={operationsOpen}
            >
              <i className="nav-icon bi bi-truck me-2" />
              Operations
            </a>
            <div
              id="navOps"
              className={`collapse ${operationsOpen ? "show" : ""}`}
              data-bs-parent="#sideNavbar"
            >
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to="/orders" className="nav-link">
                    Orders
                  </NavLink>
                </li>
                <li className="nav-item pb-2">
                  <NavLink to="/drivers" className="nav-link">
                    Drivers
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Catalog */}
          <li className="nav-item">
            <a
              className={`nav-link ${catalogOpen ? "" : "collapsed"}`}
              href="#"
              data-bs-toggle="collapse"
              data-bs-target="#navCatalog"
              aria-expanded={catalogOpen}
            >
              <i className="nav-icon bi bi-droplet me-2" />
              Catalog
            </a>
            <div
              id="navCatalog"
              className={`collapse ${catalogOpen ? "show" : ""}`}
              data-bs-parent="#sideNavbar"
            >
              <ul className="nav flex-column">
                <li className="nav-item pb-2">
                  <NavLink to="/products" className="nav-link">
                    Products
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Support */}
          <li className="nav-item">
            <a
              className={`nav-link ${supportOpen ? "" : "collapsed"}`}
              href="#"
              data-bs-toggle="collapse"
              data-bs-target="#navSupport"
              aria-expanded={supportOpen}
            >
              <i className="nav-icon bi bi-headset me-2" />
              Support
            </a>
            <div
              id="navSupport"
              className={`collapse ${supportOpen ? "show" : ""}`}
              data-bs-parent="#sideNavbar"
            >
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to="/support" className="nav-link">
                    Support Tickets
                  </NavLink>
                </li>
                <li className="nav-item pb-2">
                  <NavLink to="/notifications" className="nav-link">
                    Notifications
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          {/* Reports */}
          <li className="nav-item">
            <a
              className={`nav-link ${reportsOpen ? "" : "collapsed"}`}
              href="#"
              data-bs-toggle="collapse"
              data-bs-target="#navReports"
              aria-expanded={reportsOpen}
            >
              <i className="nav-icon bi bi-bar-chart me-2" />
              Reports
            </a>
            <div
              id="navReports"
              className={`collapse ${reportsOpen ? "show" : ""}`}
              data-bs-parent="#sideNavbar"
            >
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink to="/daily-report" className="nav-link">
                    Daily Report
                  </NavLink>
                </li>
                <li className="nav-item pb-2">
                  <NavLink to="/monthly-report" className="nav-link">
                    Monthly Report
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div className="mx-3 mb-3">
          <button
            onClick={handleLogout}
            className="btn btn-danger px-5 rounded-3 fw-normal"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Header;
